import { render, staticRenderFns } from "./ClassResourcesCard.vue?vue&type=template&id=781bb4b1"
import script from "./ClassResourcesCard.vue?vue&type=script&lang=js"
export * from "./ClassResourcesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports